import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { discardPeriodicTasks } from '@angular/core/testing';
import { ShippingLineRroute } from '../Enum/Enum';
import { IdViewModel } from '../models/IdViewModel';
import { PortSearchRequestModel } from '../models/portSearchRequestModel';

@Injectable({
  providedIn: 'root'
})
export class PortService {
  public baseurl = environment.apiUrl;
  private landingApi = "api/Landing/";
  private commonApi = "api/Common/";
  private trackingApi = "api/VoyageLocation/";
  private portcalenderApi = "api/PortCalendar/";
  private voyageApi = "api/Voyage/";
  private portApi = "api/port/";

  constructor(private http: HttpClient) { }

  GetPortData() {
    const url = this.baseurl + this.landingApi + 'GetPortData';
    return this.http.get(url).pipe();
  }
  GetPortDataByName(data) {
    const url = this.baseurl + this.landingApi + 'GetPortDataByName';
    return this.http.post(url, data).pipe();
  }
  SearchVoyages(data: any, isCountrySearch: any) {
    ``
    let url;
    if (!isCountrySearch) {
      if (data.transhipment == ShippingLineRroute.Transhipment) {
        url = `${this.baseurl}${this.voyageApi}Transhipment?${this.getVoyageUrl(data)}`;
      } else {
        url = `${this.baseurl}${this.voyageApi}Direct?${this.getVoyageUrl(data)}`;
      }
    }
    else {
      if (data.transhipment == ShippingLineRroute.Transhipment) {
        url = `${this.baseurl}${this.voyageApi}TranshipmentByCountry?${this.getVoyageByCountryUrl(data)}`;
      } else {
        url = `${this.baseurl}${this.voyageApi}DirectVoyageByCountry?${this.getVoyageByCountryUrl(data)}`;
      }
    }

    return this, this.http.get(url);
  }
  GetPortdata(data) {
    const url = this.baseurl + this.landingApi + 'GetFromAndToPortdata';
    return this, this.http.post(url, data).pipe();
  }

  GetTransitTimeDate(data) {
    const url = this.baseurl + this.landingApi + 'GetTransittimeForMonth';
    return this, this.http.post(url, data).pipe();
  }
  GetShippingLines() {
    const url = this.baseurl + this.commonApi + 'GetAllShippingLines';
    return this, this.http.get(url).pipe();
  }

  GetPortCalenderDataForMonth(data) {
    const url = this.baseurl + this.portcalenderApi + 'GetPortCalenderDetailsForVessels';
    return this, this.http.post(url, data).pipe();
  }

  GetvoyageandvesselsList() {
    const url = this.baseurl + this.commonApi + 'GetVoyageAndVesselslist';
    return this, this.http.get(url).pipe();
  }

  GetPortByCountryId(countryId) {
    const url = this.baseurl + this.commonApi + 'GetPortDatabyCountry' + "?countryId=" + countryId;
    return this, this.http.get(url).pipe();
  }

  getSelectedCountryByPortId(fromPortId, toPortId) {
    const url = this.baseurl + this.commonApi + 'GetSelectedCountryByPortId' + "?FromPortId=" + fromPortId + '&ToPortId=' + toPortId;
    return this, this.http.get(url).pipe();
  }

  GetVesselsByShippingLineId(shipsId) {
    const url = this.baseurl + this.trackingApi + 'GetVesselsByShippingLineId' + "?ShippingLineId=" + shipsId;
    return this, this.http.get(url).pipe();
  }
  GetVoyagesByVesselsId(VesselsId) {
    const url = this.baseurl + this.trackingApi + 'GetVoyagesByVesselsId' + "?VessesId=" + VesselsId;
    return this, this.http.get(url).pipe();
  }
  SaveTrackingData(data) {
    const url = this.baseurl + this.trackingApi + 'SaveTrackingData';
    return this, this.http.post(url, data).pipe();
  }
  updateTrackingData(data) {
    const url = this.baseurl + this.trackingApi + 'UpdateTrackingData';
    return this, this.http.post(url, data).pipe();
  }
  getTrackingList(data) {
    const url = this.baseurl + this.trackingApi + 'GetTrackingList';
    return this.http.post(url, data).pipe();
  }

  getTrackingDetailsByTrackingNumber(trackingNumber) {
    const url = this.baseurl + this.trackingApi + 'GetTrackingDetailsByTrackingNumber' + "?TrtackingNumber=" + trackingNumber;
    return this, this.http.get(url).pipe();
  }

  getDestinationCountryList(fromCountryId, toPortIds: number[]) {
    let url = this.baseurl + this.landingApi + 'GetDestinationCountryList' + '?fromCountryId=' + fromCountryId;
    toPortIds.forEach(x => {
      url = url + "&toPortIds=" + x;
    });
    return this.http.get(url).pipe();
  }

  getDestinationPortList(fromCountryId, toPortIds) {
    let url = this.baseurl + this.landingApi + 'GetDestinationPortList' + '?fromCountryId=' + fromCountryId;
    toPortIds.forEach(x => {
      url = url + "&toPortIds=" + x;
    });

    return this.http.get(url).pipe();
  }

  getSourceCountryList() {
    let url = this.baseurl + this.landingApi + 'GetSourceCountryList';
    return this.http.get(url).pipe();
  }

  getSourcePortList(fromCountryId) {
    const url = this.baseurl + this.landingApi + 'GetSourcePortList' + '?fromCountryId=' + fromCountryId;
    return this.http.get(url).pipe();
  }

  getVoyageUrl(data) {
    let url = "";
    if (data.searchDate) {
      url = url + `searchDate=${data.searchDate}`
    }
    if (data.toPortIds) {
      url = url + `&toPortIds=${data.toPortIds}`
    }
    if (data.toPortArrivalDate) {
      url = url + `&toPortArrivalDate=${data.toPortArrivalDate}`
    }
    if (data.fromPortIds) {
      url = url + `&fromPortIds=${data.fromPortIds}`
    }
    if (data.fromPortArrivalDate) {
      url = url + `&fromPortArrivalDate=${data.fromPortArrivalDate}`
    }
    if (data.toVesselsId) {
      url = url + `&toVesselsId=${data.toVesselsId}`
    }
    if (data.pageNo) {
      url = url + `&pageNo=${data.pageNo}`
    }
    if (data.recPerPage) {
      url = url + `&recPerPage=${data.recPerPage}`
    }
    if (data.ShippingLineIds) {
      url = url + `&shippingLineIds=${data.ShippingLineIds}`
    }
    if (data.isBasicSearch) {
      url = url + `&isBasicSearch=${data.isBasicSearch}`
    }
    if (data.userDetailsId) {
      url = url + `&userDetailsId=${data.userDetailsId}`
    }
    if (data.cubicMeter) {
      url = url + `&cubicMeter=${data.cubicMeter}`
    }
    if (data.vesselsId) {
      url = url + `&vesselsId=${data.vesselsId}`
    }
    if (data.searchBy) {
      url = url + `&searchBy=${data.searchBy}`
    }
    if (data.midPortId) {
      url = url + `&midPortId=${data.midPortId}`
    }
    if (data.transhipment) {
      url = url + `&transhipment=${data.transhipment}`
    }
    return url;
  }

  getVoyageByCountryUrl(data) {
    let url = "";
    if (data.searchDate) {
      url = url + `searchDate=${data.searchDate}`
    }
    if (data.FromCountryId) {
      url = url + `&fromCountryId=${data.FromCountryId}`
    }
    if (data.toPortArrivalDate) {
      url = url + `&toPortArrivalDate=${data.toPortArrivalDate}`
    }
    if (data.ToCountryId) {
      url = url + `&toCountryId=${data.ToCountryId}`
    }
    if (data.fromPortArrivalDate) {
      url = url + `&fromPortArrivalDate=${data.fromPortArrivalDate}`
    }
    if (data.toVesselsId) {
      url = url + `&toVesselsId=${data.toVesselsId}`
    }
    if (data.pageNo) {
      url = url + `&pageNo=${data.pageNo}`
    }
    if (data.recPerPage) {
      url = url + `&recPerPage=${data.recPerPage}`
    }
    if (data.ShippingLineIds) {
      url = url + `&shippingLineIds=${data.ShippingLineIds}`
    }
    if (data.isBasicSearch) {
      url = url + `&isBasicSearch=${data.isBasicSearch}`
    }
    if (data.userDetailsId) {
      url = url + `&userDetailsId=${data.userDetailsId}`
    }
    if (data.cubicMeter) {
      url = url + `&cubicMeter=${data.cubicMeter}`
    }
    if (data.vesselsId) {
      url = url + `&vesselsId=${data.vesselsId}`
    }
    if (data.searchBy) {
      url = url + `&searchBy=${data.searchBy}`
    }
    if (data.midPortId) {
      url = url + `&midPortId=${data.midPortId}`
    }
    if (data.transhipment) {
      url = url + `&transhipment=${data.transhipment}`
    }
    return url;
  }

  // Port Endpoints

  GetPortsList(data) {
    const url = this.baseurl + this.portApi + '?' + this.GetPortListParameters(data);
    return this.http.get(url, data);
  }

  GetPortdetailsByPortId(id) {
    const url = this.baseurl + this.portApi + id;
    return this.http.get(url);
  }
  UpdatePort(data) {
    const url = this.baseurl + this.portApi;
    return this.http.put(url, data);
  }

  AddPort(data) {
    const url = this.baseurl + this.portApi;
    return this.http.post(url, data);
  }

  CheckDuplicatePortCode(portCode) {
    const url = this.baseurl + this.portApi + 'CheckDuplicatePortCode/' + portCode;
    return this.http.get(url);
  }

  // Port ALias End point
  GetPortAlias(id) {
    const url = this.baseurl + this.portApi + 'PortAlias/' + id;
    return this.http.get(url);
  }
  UpdatePortAlias(data) {
    const url = this.baseurl + this.portApi + "PortAlias";
    return this.http.put(url, data);
  }

  AddPortAlias(data) {
    const url = this.baseurl + this.portApi + "PortAlias";
    return this.http.post(url, data);
  }

  DeletePortAlias(id) {
    const url = this.baseurl + this.portApi + "PortAlias/" + id;
    return this.http.delete(url);
  }

  private GetPortListParameters(data: PortSearchRequestModel) {
    let url = "";
    if (data.pageNo) {
      url = url + `pageNo=${data.pageNo}`
    }
    if (data.pageSize) {
      url = url + `&pageSize=${data.pageSize}`
    }
    if (data.searchText) {
      url = url + `&searchText=${data.searchText}`
    }
    if (data.sort) {
      url = url + `&sort=${data.sort}`
    }
    if (data.columnName) {
      url = url + `&columnName=${data.columnName}`
    }
    if (data.regionId) {
      url = url + `&regionId=${data.regionId}`
    }
    if (data.countryId) {
      url = url + `&countryId=${data.countryId}`
    }
    if (data.shippinglineId) {
      url = url + `&shippinglineId=${data.shippinglineId}`
    }
    if (data.IsPortCall == true || data.IsPortCall == false) {
      url = url + `&isPortCall=${data.IsPortCall}`
    }
    return url;
  }

  UpdateVesselVoyage(data) {
    const url = this.baseurl + this.voyageApi + "UpdateVoyageRouteDetailFromActivityCalendar";
    return this.http.put(url, data);
  }


  // SubmitDOM(data: any): Observable<any> {
  //   const url = this.baseurl + this.portcalenderApi + 'GetPortCalenderDetailsForVessels';
  //   const headers = new HttpHeaders({
  //     'Access-Control-Allow-Headers': 'Content-Type',
  //     'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, PATCH, DELETE',
  //     'Access-Control-Allow-Origin': '*',
  //     'Content-Type': 'application/json'
  //   });
  //   const options = { headers };
  //   return this.http.post(url, JSON.stringify(data), options).
  //   map(res => this.data = res).
  //   catch((e: any) => {
  //     return Observable.of(e);
  //   });
  // }
}
